<script setup lang="ts">
import TooltipIcon from './TooltipIcon.vue';

const props = defineProps<{
  label: string;
  modelValue: string;
  options: { label: string; value: string }[];
  tooltip?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
  <label class="input-row">
    <div class="label">
      {{ label }}
      <TooltipIcon v-if="tooltip" :text="tooltip" />
    </div>
    <select class="select" :value="modelValue" @change="emit('update:modelValue', ($event.target as HTMLSelectElement).value)">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </label>
</template>

<style scoped>
.input-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.select {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.45rem 0.55rem;
  font-size: 1rem;
}
</style>
